var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-card',{staticClass:"mt-4",attrs:{"header-tag":"header"}},[_c('h4',[_c('img',{attrs:{"src":_vm.logo}}),_c('router-link',{attrs:{"to":"/formapago"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var href = ref.href;
var route = ref.route;
var navigate = ref.navigate;
return [_c('b-button',{staticClass:"mr-2",attrs:{"href":href,"variant":"light"},on:{"click":navigate}},[_vm._v(" Cambiar Forma de Pago ")])]}}])})],1),_c('hr'),_vm._t("default"),_c('form-mercado-pago')],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }